var $ = require('jquery');

/**
 *  Start and end of preloader can be done by triggering custom event:
 *	Start preloader: $(document).trigger('FG_UNIVERSAL_PRELOADER_START','preloaderID');
 *  End preloader: $(document).trigger('FG_UNIVERSAL_PRELOADER_STOP','preloaderID');
 *  preloaderId can be any unique string identificator of current preloader
 */

var DEFAULTS = {
	html: '<div class="universal-preloader"><div class="animate"></div></div>',
	type: 'snake',	// snake | signal | bar
	visibleClass: 'visible'
};

/***
 * Universal preloader class constructor
 * @param options
 * @constructor
 */
var Preloader = function (options) {
	this.options = $.extend(true, {}, DEFAULTS, options );
	this.objects = {};
	this.activePreloaders = [];
	this._initialise();
};

/**
 * Init method, starts rendering HTML and binds events
 * @private
 */
Preloader.prototype._initialise = function(){
	this.lastIsVisible = false;
	this._renderHtml();
	this._bindEvents();
};

/**
 * Binds PRELOADER_START, PRELOADER_END events
 * @private
 */
Preloader.prototype._bindEvents = function() {
	var self = this;

	$(document).on('FG_UNIVERSAL_PRELOADER_START', function(e, data){
		self._startPreloader(data);
	}).on('FG_UNIVERSAL_PRELOADER_STOP', function(e, data){
		self._endPreloader(data);
	});
};

/***
 * Appends preloader widget at the end of body
 * @private
 */
Preloader.prototype._renderHtml = function() {
	this.objects.$preloader = $(this.options.html).addClass(this.options.type);
	$('body').append(this.objects.$preloader)
};

/**
 * Refresh preloader according to length of active preloaders array
 * @private
 */
Preloader.prototype._refreshHtml = function() {
	var isVisible = this.activePreloaders.length > 0;

	if (isVisible != this.lastIsVisible) {
		this.objects.$preloader.toggleClass(this.options.visibleClass);
	}

	this.lastIsVisible = isVisible;
};

/**
 * Start preloader, push preloader id to active preloaders array
 * @param id
 * @private
 */
Preloader.prototype._startPreloader = function(id) {
	if (this.activePreloaders.indexOf(id) == -1) {
		this.activePreloaders.push(id);
		this._refreshHtml();
	}
};

/**
 * End preloader, delete preloader id from active preloaders array
 * @param id
 * @private
 */
Preloader.prototype._endPreloader = function(id) {
	var preloaderIndex = this.activePreloaders.indexOf(id);
	if (preloaderIndex > -1) {
		this.activePreloaders.splice(preloaderIndex, 1);
		this._refreshHtml();
	}
};

module.exports = Preloader;


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/universal-preloader/preloader.js